	
(function ( $ ) {
 	"use strict";
	
	$.toggleFields = function(elem, bindType, fieldSelectorClass, relFieldSelectorId) {
		
		// not per default on checkboxes, fields must be toggled singlewise
		if(bindType > 0) {
			$(fieldSelectorClass).hide();
		}
		
		switch (bindType) {
			case 0: // checkboxes
				if( elem.is(':checked') ) {
					$(relFieldSelectorId).fadeIn();
				}
				else {
					$(relFieldSelectorId).hide();
				}
				break;
			case 1: // radio buttins
				if( elem.is(':checked') ) {
					$(relFieldSelectorId).fadeIn();
				}
				break;
			case 2: // input fields, textareas
				if( elem.val() ) {
					$(relFieldSelectorId).fadeIn();
				}
				break;
			case 3: // selects
				if( elem.val() ) {
					$(relFieldSelectorId).fadeIn();
				}
				break;
			default: // any other, e.g. links
				$(relFieldSelectorId).fadeIn();
				return false;
		}
		
		return true;
	};
	
    $.fn.cstmToggleRelatedFields = function( options ) {
 		
		var config	= {
			isInitializedClassName: 'cstm-toggle-related-initialized'
		};
		
		// have default options.
        var settings = $.extend({
            selector:				".cstm-toggle-related",
			dataAttrLayerId:		"data-cstm-toggle-layer-id",
			dataAttrLayerClass:		"data-cstm-toggle-layer-class",
            defaultEvents:			'click',
			defaultInputEvents: 	'input blur',
			defaultSelectEvents:	'change',
        }, options );
		
		var preselectedRadios = [];
		
		this.each( function() {
			
			var elem = $( this );
			
			// bind events
			var fieldId 		= elem.attr('id');
			var relLayerClass	= '.' + elem.attr(settings.dataAttrLayerClass);
			var relLayerId		= elem.attr(settings.dataAttrLayerId) ? '#' + elem.attr(settings.dataAttrLayerId) : ''; //fieldId + '_' + settings.selector.replace(/\./g, '');
			var nodeName		= elem.prop('nodeName').toLowerCase();
			
			var eventsToBind	= 'click';
			var bindType		= -1; // any, e.g. link clicked
			
			if( nodeName==='input' && (elem.attr('type')==='radio' || elem.attr('type')==='checkbox') ) {
				eventsToBind	= settings.defaultEvents;
				bindType		= elem.attr('type')==='checkbox' ? 0 : 1; // clicked checkbox or radio		
			}
			else if( nodeName==='input' || elem.prop('tagName')==='textarea' ) {
				eventsToBind	= settings.defaultInputEvents;
				bindType		= 2; // entered input value
			}
			else if( nodeName==='select' ) {
				eventsToBind	= settings.defaultSelectEvents;
				bindType		= 3; // selected value
			}
			
			if( !elem.hasClass(config.isInitializedClassName+'-events') ) {
				elem.bind(eventsToBind, function() {
					return $.toggleFields($(this), bindType, relLayerClass, relLayerId);
				}).addClass(config.isInitializedClassName+'-events');
			}
			
			// first init run
			$.toggleFields(elem, bindType, relLayerClass, relLayerId);
			
			// find id of preselected radio button
			if(bindType === 1 && elem.is(':checked')) {
				preselectedRadios[fieldId] = {
					elem: elem,
					bindType: bindType,
					fieldSelectorClass: relLayerClass, 
					relFieldSelectorId: relLayerId
				};
			}
        });
		
		// now handle preselected radios
		for(var radioId in preselectedRadios) {
			if (preselectedRadios.hasOwnProperty(radioId)) {
				$.toggleFields( preselectedRadios[radioId].elem, preselectedRadios[radioId].bindType, preselectedRadios[radioId].fieldSelectorClass, preselectedRadios[radioId].relFieldSelectorId );
			}
		}
		
		return this;
    };
 
}(jQuery));
